import { Big } from 'big.js'
import { Measure } from '../types'

enum WeightMeasurementSystem {
  metric = 'Metric Units',
  imperial = 'Imperial Units',
  usCustomary = 'US Customary Units'
}


const weightUnits = {
  microgram: {
    displayName: 'Microgram',
    codeName: 'microgram',
    url: 'microgram',
    symbol: 'μg',
    toBaseUnit: (value: Big): Big => value.div(1000000000),
    fromBaseUnit: (value: Big): Big => value.times(1000000000),
    system: WeightMeasurementSystem.metric
  },
  milligram: {
    displayName: 'Milligram',
    codeName: 'milligram',
    url: 'milligram',
    symbol: 'mg',
    toBaseUnit: (value: Big): Big => value.div(1000000),
    fromBaseUnit: (value: Big): Big => value.times(1000000),
    system: WeightMeasurementSystem.metric
  },
  gram: {
    displayName: 'Gram',
    codeName: 'gram',
    url: 'gram',
    symbol: 'g',
    toBaseUnit: (value: Big): Big => value.div(1000),
    fromBaseUnit: (value: Big): Big => value.times(1000),
    system: WeightMeasurementSystem.metric
  },
  kilogram: {
    displayName: 'Kilogram',
    codeName: 'kilogram',
    url: 'kilogram',
    symbol: 'kg',
    toBaseUnit: (value: Big): Big => value,
    fromBaseUnit: (value: Big): Big => value,
    system: WeightMeasurementSystem.metric
  },
  ton: {
    displayName: 'Metric ton',
    codeName: 'ton',
    url: 'ton',
    symbol: 't',
    toBaseUnit: (value: Big): Big => value.times(1000),
    fromBaseUnit: (value: Big): Big => value.div(1000),
    system: WeightMeasurementSystem.metric
  },

  ounce: {
    displayName: 'Ounce',
    codeName: 'ounce',
    url: 'ounce',
    symbol: 'oz',
    toBaseUnit: (value: Big): Big => value.times(0.028349523125),
    fromBaseUnit: (value: Big): Big => value.div(0.028349523125),
    system: WeightMeasurementSystem.imperial
  },
  pound: {
    displayName: 'Pound',
    codeName: 'pound',
    url: 'pound',
    symbol: 'lb',
    toBaseUnit: (value: Big): Big => value.times(0.45359237),
    fromBaseUnit: (value: Big): Big => value.div(0.45359237),
    system: WeightMeasurementSystem.imperial
  },
  stone: {
    displayName: 'Stone',
    codeName: 'stone',
    url: 'stone',
    symbol: 'st',
    toBaseUnit: (value: Big): Big => value.times(6.35029318),
    fromBaseUnit: (value: Big): Big => value.div(6.35029318),
    system: WeightMeasurementSystem.imperial
  },
  imperial_ton: {
    displayName: 'Imperial ton (long ton)',
    codeName: 'imperial_ton',
    url: 'imperial-ton',
    symbol: 'ton',
    toBaseUnit: (value: Big): Big => value.times(1016.0469088),
    fromBaseUnit: (value: Big): Big => value.div(1016.0469088),
    system: WeightMeasurementSystem.imperial
  },

  us_ton: {
    displayName: 'US ton (short ton)',
    codeName: 'us_ton',
    url: 'us-ton',
    symbol: 'ton',
    toBaseUnit: (value: Big): Big => value.times(907.18474),
    fromBaseUnit: (value: Big): Big => value.div(907.18474),
    system: WeightMeasurementSystem.usCustomary
  }
}


export const weight: Measure = {
  displayName: 'Weight',
  codeName: 'weight',
  url: 'weight',
  units: weightUnits,
  baseUnit: weightUnits.kilogram,
  defaultFromUnit: weightUnits.kilogram,
  defaultToUnit: weightUnits.pound
}
